// extracted by mini-css-extract-plugin
export default {"reportList":"ReportList_reportList__79ard","title":"ReportList_title__ZJ22z"};